import { combineEpics } from 'redux-observable';
import { Actions } from '../../actions';
import AppState from '../../state';
import { crudInventoryEpic } from './inventory';

const productEpic = combineEpics<Actions, Actions, AppState>(crudInventoryEpic);

export default productEpic;
